
namespace Matrix.Data {

    @Serenity.Decorators.registerEditor('Matrix.Data.TestPriorityEditor')
    export class TestPriorityEditor extends Serenity.Select2Editor<string, any> {

        constructor(container: JQuery) {
            super(container);

            this.addOption('LOW', 'LOW');
            this.addOption('MEDIUM', 'MEDIUM');
            this.addOption('HIGH', 'HIGH');
        }
    }
}